import { createContext } from "react";

export const ObjectContext = createContext({});